import axios from 'axios';

export const notificacionesApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/notificaciones`
});